// frontend/OtoScopDataUi.jsx
import React, { useEffect, useMemo } from "react";
import { Box, Typography, CardMedia, Grid, Button, Autocomplete, RadioGroup, FormControlLabel, Radio, Divider, Paper } from "@mui/material";
import QRCode from "react-qr-code";
import rightear from "../../assets/images/left-ear.png";
import leftear from "../../assets/images/right-ear.png";
import CustomInput from "../../components/inputs/CustomInput";
import { DRUM, WAX } from "../../utils/constants";
import { findObjectKeyByValue, titleCase } from "../../utils/helper";
import Grid2 from "@mui/material/Unstable_Grid2";
import NuConnectLogo from "../../assets/images/NuConnectLogo.svg";

const OtoScopDataUi = ({ fields, setFields, fetchFunction, isView }) => {
  return (
    <Box sx={{ width: "100%", height: "85%", display: "flex", overflow: "auto", scrollbarWidth: "none" }}>
      <Grid md={12} container>

        {!isView && <Grid md={3} sm={3} sx={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "flex-start", padding: 4, borderRight: " 2px solid #EBEBEB" }}>
          <Box gap={4} sx={{ height: "20vh", display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "flex-start" }}>
            <Box gap={4} sx={{ display: "flex", height: "5vh", alignItems: "flex-end", justifyContent: "space-between" }}>
              <img src={NuConnectLogo} alt="NuConnect Logo" />
              <Divider orientation="vertical" flexItem sx={{ borderRightWidth: 2, borderColor: "#EBEBEB" }} />
              <Typography sx={{ color: "#2D3B67", fontFamily: "League Spartan", paddingTop: "10px", fontSize: "16px", fontWeight: "bold" }}>
                Download the<br />
                NU Scope app
              </Typography>
            </Box>

            <Box>
              <Typography
                // variant="h6"
                sx={{
                  color: "#2D3B67",
                  fontFamily: "League Spartan",
                  textAlign: "left",
                  lineHeight: 1.6,
                  fontSize: "16px",
                  fontWeight: "bold",

                }}
              >
                • Open the app.<br />
                • Scan the QR Code.<br />
                • Capture pictures of both ears.
              </Typography>
            </Box>
          </Box>
          {!isView && <Box
            sx={{
              height: 180,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              mt: 4
            }}
          >
            <Paper sx={{ p: 2, border: "1px solid #D9D9D9", borderRadius: "10px", backgroundColor: "white" }}>
              <QRCode
                size={150}
                style={{ height: "17vh", maxWidth: "20vw" }}
                value={fields?._id || "No Patient ID"}
              />
            </Paper>


            <Button
              variant="outlined"
              size="large"
              onClick={() => {
                fetchFunction(fields?._id);
              }}
              sx={{ mt: 2, width: "11vw" }}
            >
              <Typography variant="h6" sx={{ fontSize: "14px" }}>Load Images</Typography>
            </Button>
          </Box>}
          <Box />

        </Grid>}


        <Grid item md={4.5} sm={4.5} sx={{ padding: 4, backgroundColor: "#FCF7F7", display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "center" }}>


          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "center", gap: 2 }}>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
              <Typography variant="h5" sx={{ color: "rgba(194, 71, 71, 1)" }}>
                Right Ear
              </Typography>
            </Box>
            <Box
              sx={{
                // p: 2,
                border: "20px solid #EED2D2",

                borderRadius: "50%",
                maxHeight: "23vh",
                maxWidth: "23vh",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {fields?.right_ear ? (
                <CardMedia
                  component="img"
                  image={fields.right_ear}
                  alt="Right Ear"
                />
              ) : (
                <CardMedia
                  component="img"
                  image={rightear}
                  alt="Right Ear"
                />
              )}
            </Box>
          </Box>

          <Box mb={4} sx={{ width: "25vw", height: "15vh" }}>

            <Autocomplete
              disableClearable
              disabled={isView}
              value={fields?.right_ear_wax ? findObjectKeyByValue(fields?.right_ear_wax, WAX) : null}
              onChange={(e, newVal) => {
                setFields({ ...fields, right_ear_wax: newVal ? newVal._id : null })
              }}
              options={[...Object.keys(WAX).map((key) => ({ label: titleCase(key), _id: WAX[key] }))]}
              sx={{ width: "100%", display: "flex", "*": { display: "flex", justifyContent: "center" } }}
              renderInput={(fields) => <CustomInput placeholder="Select Right Wax*" {...fields} label="Select Right Wax*" />}
            />

            <Autocomplete
              disableClearable
              disabled={isView}
              value={fields?.right_eardrum ? findObjectKeyByValue(fields?.right_eardrum, DRUM) : null}
              onChange={(e, newVal) => {
                const newEardrum = newVal ? newVal._id : null;
                setFields({
                  ...fields,
                  right_eardrum: newEardrum,
                  is_discharge_right: newEardrum === DRUM.PERFORATED ? fields.is_discharge_right : null
                });
                // setFields({ ...fields, right_eardrum: newVal ? newVal._id : null ,is_discharge_right: fields.right_eardrum === DRUM.PERFORATED ? fields.is_discharge_right : null})
              }}

              options={[...Object.keys(DRUM).map((key) => ({ label: titleCase(key), _id: DRUM[key] }))]}
              sx={{ width: "100%", display: "flex", "*": { display: "flex", justifyContent: "center" } }}
              renderInput={(fields) => <CustomInput placeholder="Select Right Drum*" {...fields} label="Select Right Drum*" />}
            />
            {fields?.right_eardrum == DRUM.PERFORATED &&
              <Box sx={{ marginLeft: "10px" }}>
                <RadioGroup
                  sx={{
                    top: "-6px",
                    left: "90px",
                  }}
                  row
                  disabled={isView}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <Box sx={{ display: "flex" }}>
                    <FormControlLabel
                      // disabled={loading}
                      disabled={isView}
                      checked={fields?.is_discharge_right === true}
                      onChange={(e) => {
                        setFields({ ...fields, is_discharge_right: true });
                      }}
                      value={true}
                      control={<Radio />}
                      label={<Typography variant="h6" sx={{ fontSize: "14px" }}>Discharge Active</Typography>}
                    />
                    <FormControlLabel
                      disabled={isView}
                      checked={fields?.is_discharge_right === false}
                      onChange={(e) => {
                        setFields({ ...fields, is_discharge_right: false });
                      }}
                      // disabled={loading}
                      value={false}
                      control={<Radio />}
                      label={<Typography variant="h6" sx={{ fontSize: "14px" }}>Discharge Inactive</Typography>}
                    />
                  </Box>
                </RadioGroup>
              </Box>

            }
          </Box>
        </Grid>


        <Grid item md={4.5} sm={4.5} sx={{ padding: 4, backgroundColor: "#F6FBFE", display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "center" }}>


          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "center", gap: 2 }}>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
              <Typography variant="h5" sx={{ color: "rgba(18, 101, 161, 1)" }}>
                Left Ear
              </Typography>
            </Box>

            <Box
              sx={{
                // p: 2,
                border: "20px solid #C8E7F9",
                borderRadius: "50%",
                maxHeight: "23vh",
                maxWidth: "23vh",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {fields?.left_ear ? (
                <CardMedia
                  component="img"
                  image={fields.left_ear}
                  alt="Left Ear"
                />
              ) : (
                <CardMedia
                  component="img"
                  // height="350"
                  image={leftear}
                  alt="Left Ear"
                />
              )}
            </Box>
          </Box>

          <Box mb={4} sx={{ width: "25vw", height: "15vh" }}>
            <Autocomplete
              disableClearable
              disabled={isView}
              value={fields?.left_ear_wax ? findObjectKeyByValue(fields?.left_ear_wax, WAX) : null}

              onChange={(e, newVal) => {
                setFields({ ...fields, left_ear_wax: newVal ? newVal._id : null })
              }}
              options={[...Object.keys(WAX).map((key) => ({ label: titleCase(key), _id: WAX[key] }))]}
              sx={{ width: "100%", display: "flex", "*": { display: "flex", justifyContent: "center" } }}
              renderInput={(fields) => <CustomInput placeholder="Select Left Wax*" {...fields} label="Select Left Wax*" />}
            />

            <Autocomplete
              disableClearable
              disabled={isView}
              value={fields?.left_eardrum ? findObjectKeyByValue(fields?.left_eardrum, DRUM) : null}

              onChange={(e, newVal) => {
                const newEardrum = newVal ? newVal._id : null;
                setFields({
                  ...fields,
                  left_eardrum: newEardrum,
                  is_discharge_left:
                    newEardrum === DRUM.PERFORATED ? fields?.is_discharge_left : null
                });
                // setFields({ ...fields, left_eardrum: newVal ? newVal._id : null,is_discharge_left: fields.left_eardrum === DRUM.PERFORATED ? fields.is_discharge_left : null })
              }}
              options={[...Object.keys(DRUM).map((key) => ({ label: titleCase(key), _id: DRUM[key] }))]}
              sx={{ width: "100%", display: "flex", "*": { display: "flex", justifyContent: "center" } }}
              renderInput={(fields) => <CustomInput placeholder="Select Left Drum*" {...fields} label="Select Left Drum*" />}
            />
            {fields?.left_eardrum == DRUM.PERFORATED &&
              <Box sx={{ marginLeft: "10px" }}>
                <RadioGroup
                  sx={{
                    top: "-6px",
                    left: "90px",
                  }}
                  // disabled={isView}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <Box sx={{ display: "flex" }}>
                    <FormControlLabel
                      // disabled={loading}
                      disabled={isView}
                      checked={fields?.is_discharge_left === true}
                      onChange={(e) => {
                        setFields({ ...fields, is_discharge_left: true });
                      }}
                      value={true}
                      control={<Radio />}
                      label={<Typography variant="h6" sx={{ fontSize: "14px" }}>Discharge Active</Typography>}
                    />
                    <FormControlLabel
                      disabled={isView}
                      checked={fields?.is_discharge_left === false}
                      onChange={(e) => {
                        setFields({ ...fields, is_discharge_left: false });
                      }}
                      // disabled={loading}
                      value={false}
                      control={<Radio />}
                      label={<Typography variant="h6" sx={{ fontSize: "14px" }}>Discharge Inactive</Typography>}
                    /></Box>

                </RadioGroup>
              </Box>

            }
          </Box>
        </Grid>


        {/* <Box sx={{ marginTop: "-100px", width: "10px", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}> <Box sx={{ backgroundColor: "rgba(194, 71, 71, 1)", width: "10px", height: "60%", borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px" }}></Box></Box> */}
      </Grid>
    </Box>
  );
};

export default OtoScopDataUi;